import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcTools = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M15.381 10.58 18.2 7.45h1.5l2-3.5-1.5-1.5-3.5 2v1.5l-3.13 2.817 1.812 1.813Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "m8.236 13.336-5.032 4.673a2.044 2.044 0 1 0 2.889 2.889l4.672-5.032-2.529-2.53Z",
  fill: "var(--mds-nav-icon-weak)"
}), /* @__PURE__ */ React.createElement("path", {
  d: "M2.3 6.95c0-.607.12-1.185.338-1.713l2.595 2.595 1.931-.518.518-1.932-2.595-2.595a4.5 4.5 0 0 1 5.775 6.102l9.5 9.5a1.5 1.5 0 1 1-2.122 2.121l-9.5-9.5A4.5 4.5 0 0 1 2.3 6.95Z",
  fill: "var(--mds-nav-icon-accent)"
})), "IcTools");

export { IcTools };
//# sourceMappingURL=ic-tools.js.map
